import React, { useState, useEffect } from 'react'
import { Button, Flex, Affix, Select, Spin, Input, notification, Row, Col, Drawer, Tag, Checkbox, Space, Dropdown, Modal } from 'antd';
import { EditOutlined, UserAddOutlined, DeleteFilled, EditFilled, DownOutlined, LikeFilled, CloseCircleOutlined, DownloadOutlined } from '@ant-design/icons';
import { useCustomer } from '../hook/CustomerHook'
import { useSchool } from '../hook/SchoolHook';
import InputFormByObject from '../common/dynamic-form/InputFormByObject';
import UIObject from '../common/dynamic-form/UIObject';
import BaseGameObject from '../objects/BaseGameObject';
import CustomerObject, { CUSTOMER_SOURCE, CUSTOMER_STATUS, statusColor } from '../objects/CustomerObject';
import { isMobile } from 'react-device-detect';
import { searchInObject } from '../common/Search';
import { getDate } from '../common/Converter';
import innerText from 'react-innertext';
import * as XLSX from 'xlsx';


import dayjs from 'dayjs';
import { InputField } from '../common/dynamic-form/InputField';
import CustomerRowComponent from './customer/CustomerRowComponent';


export default function SC03_Customer(props) {
    const { schools, updateSchool, addNewSchool } = useSchool();
    const { customers, updateCustomer, addNewCustomer, deleteCustomers, changeStatus } = useCustomer();
    const [customerList, setCustomerList] = useState(null);
    const [schoolData, setSchoolData] = useState([]);
    const [schoolsOption, setSchoolsOption] = useState([]);
    const [classList, setClassList] = useState([]);
    const [selectedSchool, setSelectedSchool] = useState(null);
    const [selectedClass, setSelectedClass] = useState(null);
    const [userSelected, setUserSelected] = useState(new CustomerObject({ source: CUSTOMER_SOURCE.MANUAL_INPUT.key }))
    const [isEditMode, setIsEditMode] = useState(false);
    const [finalData, setFinalData] = useState(null);
    const [open, setOpen] = useState(false);
    // const [messageApi, contextHolder] = message.useMessage();
    const [api, contextHolder] = notification.useNotification();
    const [textSearch, setTextSearch] = useState(null);
    const [checked, setChecked] = useState([]);
    const [isCheckAll, setIsCheckAll] = useState(false);
    const [canEditMulti, setCanEditMulti] = useState(false);
    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false)
    const [loading, setLoading] = useState(false);
    const [isOpenEditModal, setIsOpenEditModal] = useState(false)
    const [existingUserIds, setExistingUserIds] = useState([])
    const [currentRawSelectedUser, setCurrentRawSelectedUser] = useState(null)
    const [newStatus, setNewStatus] = useState(CUSTOMER_STATUS.ACTIVE)
    const [selectedUsersToExport, setSelectedUsersToExport] = useState([])

    useEffect(() => {
        if (customers && Array.isArray(customers) && schools && Array.isArray(schools)) {
            setCustomerList(customers);
            //Get list school & class
            const schoolList = [...schools];
            customers.forEach(customer => {
                const schoolIndex = schoolList.findIndex(t => t.id === customer.school);
                if (schoolIndex == -1) {
                    schoolList.push({ school: customer.school, classes: customers.class ? [customer.class] : [] })
                } else if (customer.class) {
                    if (schoolList[schoolIndex].classes)
                        schoolList[schoolIndex].classes = [...schoolList[schoolIndex].classes, customer.class]
                    else
                        schoolList[schoolIndex].classes = [customer.class]
                }
            });
            setSchoolData(schoolList);
        }
    }, [customers, schools])

    useEffect(() => {
        if (schools && Array.isArray(schools)) {
            const allSchools = [{ value: "", label: <span><i>Tất cả các trường</i></span> }]
            schools.forEach(school => {
                allSchools.push({ value: school.id, label: <span>{school.name} <b><i>({school.id})</i></b></span> })
            });
            setSchoolsOption(allSchools);
        }
        if (customers && Array.isArray(customers) && customers.length > 0) {
            const allUserIds = []
            customers.forEach((customer) => {
                allUserIds.push(customer.userId)
            })
            setExistingUserIds(allUserIds)
        }
    }, [customers])

    useEffect(() => {
        if (checked && Array.isArray(checked) && checked.length > 0) {
            setCanEditMulti(true)
        } else setCanEditMulti(false)
    }, [checked])

    useEffect(() => {
        if (selectedSchool) {
            const schoolIndex = schoolData.findIndex(s => s.id === selectedSchool)
            if (schoolIndex != -1) {
                // console.log("SCHOOL DATA: ", schoolData[schoolIndex], schoolIndex)
                const classData = schoolData[schoolIndex].classes
                const classes = [{ value: "", label: <span>Tất cả các lớp</span> }]
                if (classData && Array.isArray(classData)) {
                    classData.forEach(classObj => {
                        if (classes.findIndex(c => c.value === classObj) == -1)
                            classes.push({ value: classObj, label: <span>{classObj}</span> })
                    });
                }
                setClassList(classes);
            }
        }

        setChecked([])
        setSelectedUsersToExport([])
        setIsCheckAll(false)
    }, [selectedSchool])
    // const statusList =[]
    // Object.keys(CUSTOMER_STATUS).forEach(item => {
    //     statusList.push({ value: `${CUSTOMER_STATUS[item].key}`, label: <span>{CUSTOMER_STATUS[item].label}</span> })
    //     // statusList.push({ value: `${item}`, label: <span>{CUSTOMER_STATUS[item].label}</span> })
    // })

    useEffect(() => {
        if (selectedClass) {
            setIsCheckAll(false)
            setChecked([])
            setSelectedUsersToExport([])
        }
    }, [selectedClass])


    const createNewCustomer = () => {
        setUserSelected(null)
        setCurrentRawSelectedUser(null)
        setIsEditMode(false)
        const newGame = new CustomerObject({ source: CUSTOMER_SOURCE.MANUAL_INPUT.key });
        newGame.addHiddenField('key');
        newGame.convertFieldToSelect('school', schoolsOption);
        newGame.mapData();
        setUserSelected(newGame)
        setOpen(true);
    }

    const updateInfo = (customer) => {
        setUserSelected(customer)
        setIsEditMode(true)
    }

    const onClose = () => {
        setUserSelected(null)
        setCurrentRawSelectedUser(null)
        setOpen(false);
    };
    const error = (message) => {
        api['error']({
            message: "Chỉnh sửa thông tin người dùng thất bại!",
            description: message,
            zIndexPopup: 99999,
            duration: 10
        })
    };


    const openSuccessNoti = (phone) => {
        console.log("SUCCESS UPDATE USER =============")
        const content = <Flex vertical>
            <div>{isEditMode ? "Hãy kiểm tra lại thông tin để tránh nhầm lẫn!" : "Hãy kiểm tra lại trạng thái và ngày hết hạn của tài khoản mới để đảm bảo không nhầm lẫn"}</div>
            <Flex justify='space-evenly' style={{ fontWeight: "bold" }} ><div>User Id: </div><div>{phone}</div></Flex>
        </Flex>
        api.success({
            message: `Chúc mừng bạn đã ${isEditMode ? "chỉnh sửa thông tin" : "tạo mới"} người dùng thành công!`,
            duration: 0,
            zIndexPopup: 99999,
            description: content,
            width: '800px'
        })
    };

    const onSubmit = async (values) => {
        if (finalData) {
            console.log("Old value: ", currentRawSelectedUser)
            if (currentRawSelectedUser && currentRawSelectedUser.userId !== finalData.userId) {
                const userIdExisted = customers.findIndex(c => c.userId === finalData.userId) == -1 ? false : true;
                if (userIdExisted) {
                    error(`Không thể lưu! Id đăng nhập "${finalData.userId}" đã tồn tại trên hệ thống.`)
                    return;
                }
            }
            delete finalData.listUserIds;
            finalData.key = currentRawSelectedUser ? currentRawSelectedUser.key : finalData.userId;
            console.log("Final data to submit: ", finalData);
            if(finalData.status === undefined || finalData.status === null || (!finalData.status && finalData.status !== 0)) {
                console.log("STATUS IS NULL OR UNDEFINED, SET TO ACTIVE");
                finalData.status = CUSTOMER_STATUS.ACTIVE.key
            }
            finalData.expired = dayjs(finalData.expired).toDate()
            finalData.birthday = dayjs(finalData.birthday).toDate()
            let res = await updateCustomer(finalData);
            if (!res.error) {
                // messageApi.success("Update User successful!")
                openSuccessNoti(finalData.userId)
                setFinalData(null)
                setOpen(false)
            } else error(`Lưu trữ thất bại: "${res.message}"`)
        }
    }
    const handleMenuClick = e => {
        // message.info('Click on menu item.');
        console.log('click', e);
        switch (e.key) {
            case 'delete': setIsOpenDeleteModal(true); break;
            case 'edit': setIsOpenEditModal(true); break;
            case 'export': exportSelectedUser(true); break;
            default: setIsOpenEditModal(true);
        }
    };
    const items = [
        {
            label: 'Thay đổi trạng thái',
            key: 'edit',
            icon: <EditFilled />,
        },
        // {
        //     label: 'Xuất file Excel',
        //     key: 'export',
        //     icon: <DownloadOutlined />,
        // },
        {
            label: 'Xoá',
            key: 'delete',
            danger: true,
            icon: <DeleteFilled />,
        },
    ];
    const menuProps = {
        items,
        onClick: handleMenuClick,
    };

    const handleCancel = () => {
        setIsOpenDeleteModal(false);
        setIsOpenEditModal(false);
    };
    const deleteSelected = async () => {
        setLoading(true)
        const res = await deleteCustomers(checked)
        console.log("DELETE RESPONSE: ", res)
        setLoading(false);
        setIsOpenDeleteModal(false);
        if (res.successed) {
            api.success({
                message: "Thành công!",
                duration: 0,
                zIndexPopup: 99999,
                description: `Xoá ${res.totalDelete} người dùng thành công!`,
                width: '800px'
            })
        } else {
            api['error']({
                message: "Xoá người dùng thất bại!",
                description: `${res.message}: ${res.cannotDelete.map((user, index) => <Tag key={index}>{user}</Tag>)}`,
                zIndexPopup: 99999,
                duration: 10
            })
        }
    }
    const editSelected = async () => {
        setLoading(true)
        const editList = []
        checked.forEach(user => {
            editList.push({ userId: user, status: newStatus })
        })
        const res = await changeStatus(editList)
        console.log("Edit RESPONSE: ", res)
        setLoading(false);
        setIsOpenEditModal(false);
        if (res.successed) {
            api.success({
                message: "Thành công!",
                duration: 0,
                zIndexPopup: 99999,
                description: `Cập nhật trạng thái của ${res.totalDelete} người dùng thành công!`,
                width: '800px'
            })
        } else {
            api['error']({
                message: "Cập nhật trạng thái thất bại!",
                description: `${res.message}: ${res.cannotDelete.map((user, index) => <Tag key={index}>{user}</Tag>)}`,
                zIndexPopup: 99999,
                duration: 10
            })
        }
    }

    const exportSelectedUser = async () => {
        try {
            const worksheet = XLSX.utils.json_to_sheet(selectedUsersToExport);

            // Tạo workbook
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Danh sách user");

            // Xuất file
            await XLSX.writeFile(workbook, "danh_sach.xlsx");
            api.success({
                message: "Xuất file Thành công!",
                duration: 0,
                zIndexPopup: 99999,
                description: `Đã xuất ${selectedUsersToExport.length} người dùng thành công. Hãy kiểm tra trong thư mục Download!`,
                width: '800px'
            })
        } catch (error) {
            console.error('Error processing Excel file:', error);
            api['error']({
                message: "Xuất file thất bại!",
                description: error,
                zIndexPopup: 99999,
                duration: 10
            })
        }
    }

    const dataSourceSchool = searchInObject(customerList, selectedSchool, ['school']);
    const dataSourceClass = searchInObject(dataSourceSchool, selectedClass, ['class']);
    const dataSource = searchInObject(dataSourceClass, textSearch, ['name', 'nameFather', 'nameMother', 'userId', 'maHs', 'phoneFather', 'phoneMother']);

    return (
        <>
            {contextHolder}
            <Flex style={{ marginBottom: '20px', position:'sticky',  }} justify='space-between' wrap gap="small" key='header'>
                <div style={{ fontStyle: 'italic', fontSize: '11pt' }}>Danh sách người dùng: </div>

                <Flex gap="small" wrap>
                    <Select
                        style={{ width: "220px", border: '1px #cfcfcf solid' }}
                        variant="outlined"
                        showSearch
                        placeholder="Lọc theo trường học"
                        filterOption={(input, option) =>
                            (innerText(option?.label ?? '')).toLowerCase().includes(input.toLowerCase())
                        }
                        options={schoolsOption}
                        onChange={e => setSelectedSchool(e)}
                    />
                    <Select
                        style={{ width: "160px", border: '1px #cfcfcf solid' }}
                        showSearch
                        placeholder="Lọc theo lớp"
                        options={classList}
                        onChange={e => setSelectedClass(e)}
                    />
                    <Input placeholder="Tìm kiếm" onChange={(e) => {
                        setTextSearch(e.target.value);
                        console.log("TEXT: ", e.target.value);
                    }} style={{ width: "200px" }} />
                </Flex>
                <Flex gap="small" wrap style={{position:'sticky', top:0}}>
                    <Dropdown menu={menuProps}>
                        <Button color="primary" disabled={!canEditMulti} variant="outlined" icon={<EditOutlined />}>
                            <Space>
                                Xử lý nhiều...
                                <DownOutlined />
                            </Space></Button>
                    </Dropdown>
                    <Button color="cyan" variant="solid" style={{ backgroundColor: '#0fd1d1' }} onClick={createNewCustomer} icon={<UserAddOutlined />}>Tạo mới</Button>
                </Flex>
            </Flex>
            <Flex vertical gap={'0px'} wrap key="content">
                <Row style={{ fontWeight: 'bold', marginBottom: '10px' }} key="row1">
                    {/* <Col flex="30px"> </Col> */}
                    {/* <Affix offsetTop={50}> */}
                    <Col xs={{ flex: '100%' }} sm={{ flex: '100%' }} md={{ flex: '40%' }} lg={{ flex: '20%' }} xl={{ flex: '20%' }}>

                        <Checkbox checked={isCheckAll} onChange={(e) => {
                            if (e.target.checked) {
                                const newChecked = []
                                const selected = []
                                dataSource.forEach(user => {
                                    newChecked.push(user.userId)
                                    const standardUser = { ...user }
                                    standardUser.expired = dayjs(standardUser.expired).format('DD/MM/YYYY')
                                    standardUser.birthday = dayjs(standardUser.birthday).format('DD/MM/YYYY')
                                    standardUser.status = Object.values(CUSTOMER_STATUS).find(t => t.key === standardUser.status).label
                                    delete standardUser.schoolData
                                    delete standardUser.source
                                    selected.push(standardUser)
                                });
                                setChecked(newChecked)
                                setSelectedUsersToExport(selected)
                                setIsCheckAll(true)
                            } else {
                                setChecked([])
                                setSelectedUsersToExport([])
                                setIsCheckAll(false)
                            }
                        }}></Checkbox> &nbsp;&nbsp;&nbsp; {isMobile ? "Chọn tất cả" : "Tên người dùng"}</Col>
                    {/* </Affix> */}
                    {
                        isMobile ? null :
                            [
                                <Col xs={{ flex: '100%' }} sm={{ flex: '100%' }} md={{ flex: '40%' }} lg={{ flex: '15%' }} xl={{ flex: '15%' }}>Id đăng nhập</Col>,
                                <Col xs={{ flex: '100%' }} sm={{ flex: '100%' }} md={{ flex: '40%' }} lg={{ flex: '15%' }} xl={{ flex: '15%' }}>Nguồn gốc</Col>,
                                <Col xs={{ flex: '100%' }} sm={{ flex: '100%' }} md={{ flex: '40%' }} lg={{ flex: '15%' }} xl={{ flex: '15%' }}>Ngày hết hạn</Col>,
                                <Col xs={{ flex: '100%' }} sm={{ flex: '100%' }} md={{ flex: '20%' }} lg={{ flex: '20%' }} xl={{ flex: '20%' }}>Trường học</Col>,
                                <Col xs={{ flex: '100%' }} sm={{ flex: '100%' }} md={{ flex: '40%' }} lg={{ flex: '15%' }} xl={{ flex: '15%' }}>Trạng thái</Col>
                            ]

                    }
                </Row>
                {
                    dataSource == null ?
                        <Spin />
                        : ((Array.isArray(dataSource) && dataSource.length > 0) ?
                            dataSource.map((customer, index) => <CustomerRowComponent key={index} keyOfRow={customer.userId} index={index} customer={customer} isCheckAll={isCheckAll}
                                onChangeCheck={(isChecked) => {
                                    const checkIndex = checked.findIndex(c => c === customer.userId)
                                    const checkIndexInSelected = selectedUsersToExport.findIndex(c => c.userId === customer.userId)
                                    const newChecked = [...checked]
                                    const selected = [...selectedUsersToExport]
                                    if (isChecked) {
                                        if (checkIndex == -1) {
                                            newChecked.push(customer.userId)
                                            const standardUser = { ...customer }
                                            standardUser.expired = dayjs(standardUser.expired).format('DD/MM/YYYY')
                                            standardUser.birthday = dayjs(standardUser.birthday).format('DD/MM/YYYY')
                                            standardUser.status = Object.values(CUSTOMER_STATUS).find(t => t.key === standardUser.status).label
                                            delete standardUser.schoolData
                                            delete standardUser.source
                                            selected.push(standardUser)
                                            setChecked(newChecked)
                                            setSelectedUsersToExport(selected)
                                        }
                                    } else {
                                        if (checkIndex != -1) {
                                            newChecked.splice(checkIndex, 1)
                                            selected.splice(checkIndexInSelected, 1)
                                            setChecked(newChecked)
                                            setSelectedUsersToExport(selected)
                                        }
                                    }
                                    console.log("Checked: ", newChecked)
                                }}
                                openDetail={(e) => {
                                    const iCustomer = new CustomerObject({ ...customer, listUserIds: existingUserIds })
                                    iCustomer.addLockedField('source')
                                    iCustomer.addHiddenField('key')
                                    iCustomer.convertFieldToSelect('school', schoolsOption);
                                    setUserSelected(iCustomer)
                                    setIsEditMode(true)
                                    setOpen(true)
                                    setCurrentRawSelectedUser(customer)
                                }} />)
                            : <div>Không tìm thấy người dùng nào</div>)
                }
            </Flex>
            <Drawer
                title={isEditMode ? "Chỉnh sửa thông tin người dùng" : "Thêm mới người dùng"}
                placement="right"
                width={isMobile ? "100vw" : "80vw"}
                onClose={onClose}
                open={open}
            >
                <div style={{ width: "100%" }}>
                    {userSelected ?
                        <div style={{ width: "60%", minWidth: "340px" }}>
                            <div style={{ fontWeight: "bold", fontSize: "12pt", marginBottom: "10px" }}>THÔNG TIN NGƯỜI DÙNG</div>
                            <InputFormByObject submitButton="Lưu" uiObject={userSelected} onSubmit={onSubmit} onChange={(data) => { setFinalData(data); console.log("INPUT FORM CHANGED TO: ", data) }} />
                        </div>
                        : null}

                </div>
            </Drawer>
            <Modal
                title="Hành động này không thể khôi phục. Bạn có chắc chắn muốn xoá những người dùng sau?"
                closable={{ 'aria-label': 'Custom Close Button' }}
                open={isOpenDeleteModal}
                onOk={deleteSelected}
                onCancel={handleCancel}
                footer={[
                    <Button key="back" onClick={handleCancel} >
                        <CloseCircleOutlined />
                        Bỏ qua
                    </Button>,
                    <Button
                        key="sumit"
                        type="primary"
                        danger
                        loading={loading}
                        onClick={deleteSelected}
                    >
                        <LikeFilled /> Chắc chắn muốn Xoá
                    </Button>,
                ]}
            >
                <p>Có phải bạn đang muốn xoá tổng cộng {checked.length} người dùng sau:</p>
                <Flex style={{ overflowY: "scroll", maxHeight: '250px', margin: 0, padding: "10px" }} wrap>
                    {
                        (checked && Array.isArray(checked)) ?
                            checked.map((item, index) => {
                                return <Tag key={index}>{item}</Tag>
                            })
                            : <p>Không có người dùng nào được chọn</p>
                    }
                </Flex>
            </Modal>
            <Modal
                title="Thay đổi trạng thái cho các người dùng đã chọn"
                closable={{ 'aria-label': 'Custom Close Button' }}
                open={isOpenEditModal}
                onOk={editSelected}
                onCancel={handleCancel}
                footer={[
                    <Button key="back" onClick={handleCancel} >
                        <CloseCircleOutlined />
                        Bỏ qua
                    </Button>,
                    <Button
                        key="sumit"
                        type="primary"
                        danger
                        loading={loading}
                        onClick={editSelected}
                    >
                        <LikeFilled /> Thay đổi
                    </Button>,
                ]}
            >
                <p>Thay đổi trạng thái hàng loạt cho {checked.length} người dùng sau:</p>
                <Flex style={{ overflowY: "scroll", maxHeight: '250px', margin: 0, padding: "10px" }} wrap>
                    <Select
                        // defaultValue={CUSTOMER_STATUS.ACTIVE.label}
                        // value={newStatus}
                        placeholder="Chọn trạng thái mới"
                        style={{ width: 200, zIndex: "9999 !important", border: "1px solid gray", backgroundColor: "#e0e0e0d9", borderRadius: "5px" }}
                        onChange={e => setNewStatus(e)}
                        options={Object.keys(CUSTOMER_STATUS).map(item => ({ value: CUSTOMER_STATUS[item].key, label: <span>{CUSTOMER_STATUS[item].label}</span> }))}
                    />
                </Flex>
            </Modal>
        </>
    )
}